import NameSpace from '../ns/NameSpace'
import DataManager from '../data/DataManager'
import LocationUtil from '../util/LocationUtil'

/**
 * アセット管理用クラス
 */
class AssetsMananger {

  // ---------------------------------------------------------------------------------------------------------
  // --	AssetsMananger
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor()
  {
    this.config = new Map()
    this.resources = new Map()
    this.soundDelayTimers = new Map()
    this.soundLockFlag = false
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	読み込み
  // ---------------------------------------------------------------------------------------------------------

  /**
   * Configファイル読み込み
   */
  loadConfig(ns, baseDir)
  {
    return new Promise((resolve, reject) => {

      // console.log('loadConfig:' + baseDir)

      //ローダー生成
      const loader = new PIXI.Loader();
      loader.add('config', baseDir + 'config.json')

      //エラーのハンドリング
      loader.onError.add(e => {
        throw new Error('ファイルの読み込みに失敗しました')
      })

      //読み込み
      loader.load((loader, resources) => {
        // console.log(resources);
        this.config.set(ns, resources.config.data);
        resolve()
      })
    })
  }

  /**
   * 共通素材読み込み
   */
  loadCommonAssets()
  {
    return new Promise((resolve, reject) => {

      if(this.resources.has('common'))
      {
        console.log('共通アセットはすでに読み込まれています。');
        resolve();
        return;
      }

      //ローダー生成
      const loader = new PIXI.Loader();

      //共通画像
      loader.add('hanamaru', LocationUtil.getCDNPath('/assets/img/hanamaru.png'))
      loader.add('hanamaru_correct', LocationUtil.getCDNPath('/assets/img/hanamaru_correct.png'))
      loader.add('hatena', LocationUtil.getCDNPath('/assets/img/hatena.png'))
      loader.add('progress_arrow', LocationUtil.getCDNPath('/assets/img/progress_arrow.png'))
      loader.add('ss_clear-0', LocationUtil.getCDNPath('/assets/img/ss_clear-0.json'))
      loader.add('ss_clear-1', LocationUtil.getCDNPath('/assets/img/ss_clear-1.json'))
      loader.add('common_modal', LocationUtil.getCDNPath('/assets/img/common_modal.json'))
      loader.add('common_close_btn', LocationUtil.getCDNPath('/assets/img/common_close_btn.png'))

      //正解・不正解用のしまジロー
      const correct_path = (DataManager.getData('shimajiro_correct'))?DataManager.getData('shimajiro_correct'):'/assets/img/shimajiro_correct.png'
      const wrong_path = (DataManager.getData('shimajiro_wrong'))?DataManager.getData('shimajiro_wrong'):'/assets/img/shimajiro_wrong.png'
      console.log('correct_path:' + correct_path)
      console.log('wrong_path:' + wrong_path)
      loader.add('shimajiro_correct', LocationUtil.getCDNPath(correct_path, false))
      loader.add('shimajiro_wrong', LocationUtil.getCDNPath(wrong_path, false))

      //共通サウンド
      loader.add('sound_success', LocationUtil.getCDNPath('/assets/sound/sound_success.mp3'))
      loader.add('sound_clear', LocationUtil.getCDNPath('/assets/sound/sound_clear.mp3'))
      loader.add('sound_stamp', LocationUtil.getCDNPath('/assets/sound/sound_stamp.mp3'))
      loader.add('sound_yattane', LocationUtil.getCDNPath('/assets/sound/sound_yattane.mp3'))
      loader.add('sound_wrong', LocationUtil.getCDNPath('/assets/sound/sound_wrong.mp3'))
      loader.add('sound_dekita', LocationUtil.getCDNPath('/assets/sound/sound_dekita.mp3'))
      loader.add('sound_correct', LocationUtil.getCDNPath('/assets/sound/sound_correct.mp3'))
      loader.add('sound_quit', LocationUtil.getCDNPath('/assets/sound/sound_quit.mp3'))
      loader.add('sound_furikaeri_quit', LocationUtil.getCDNPath('/assets/sound/sound_furikaeri_quit.mp3'))
      loader.add('sound_reload', LocationUtil.getCDNPath('/assets/sound/sound_reload.mp3'))
      loader.add('sound_tap', LocationUtil.getCDNPath('/assets/sound/sound_tap3.mp3'))
      loader.add('sound_drag', LocationUtil.getCDNPath('/assets/sound/sound_drag.mp3'))
      loader.add('sound_fit', LocationUtil.getCDNPath('/assets/sound/sound_fit.mp3'))

      //エラーのハンドリング
      loader.onError.add(e => {
        console.log(e)
        throw new Error('ファイルの読み込みに失敗しました')
      })

      //読み込み
      loader.load((loader, resources) => {
        this.resources.set('common', resources);
        // console.log(this.resources.get('common'));
        resolve()
      })
    })
  }

  /**
   * イベントコンテンツ用のAssets読み込み
   */
  loadAssetsByConfig(ns, baseDir)
  {
    return new Promise((resolve, reject) => {

      //ローダー生成
      const loader = new PIXI.Loader();

      //コンテンツ用の素材読み込み
      const config = this.config.get(ns);
      const assets = config.assets;
      const len = assets.length;
      for(let i=0; i<len; i++)
      {
        const asset = assets[i];
        let path = asset.path;
        if(path.indexOf('./') == 0)
        {
          path = baseDir + path.split('./')[1];
          path = LocationUtil.getCDNPath(path, false)
        }
        else if(path.indexOf('/') == 0)
        {
          path = LocationUtil.getCDNPath(path, true)
        }
        // console.log('path:' + path);
        loader.add(asset.id, path);
      }

      //エラーのハンドリング
      loader.onError.add(e => {
        console.log(e)
        throw new Error('ファイルの読み込みに失敗しました')
      })

      //読み込み
      loader.load((loader, resources) => {
        this.resources.set(ns, resources);
        // console.log(this.resources.get(ns));
        resolve()
      })
    })
  }

  /**
   * 移動コンテンツ用のAssets読み込み
   */
  loadAssets(ns, assets)
  {
    return new Promise((resolve, reject) => {

      //ローダー生成
      const loader = new PIXI.Loader();

      //コンテンツ用の素材読み込み
      const len = assets.length
      for(let i=0; i<len; i++)
      {
        const asset = assets[i]
        // let path = asset.path
        // path = LocationUtil.getCDNPath(path)
        loader.add(asset.id, asset.path)
      }

      //エラーのハンドリング
      loader.onError.add(e => {
        console.log(e)
        throw new Error('ファイルの読み込みに失敗しました')
      })

      //読み込み
      loader.load((loader, resources) => {
        this.resources.set(ns, resources);
        console.log(this.resources.get(ns));
        resolve()
      })
    })
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	取得
  // ---------------------------------------------------------------------------------------------------------

  /**
   * Config取得
   */
  getConfig(ns)
  {
    return this.config.get(ns);
  }

  /**
   * 配置したDisplayObjectをnameで取得
   */
  getObjByName(name)
  {
    const root = DataManager.getData('root');
    return root.getChildByName(name);
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	生成
  // ---------------------------------------------------------------------------------------------------------

  /**
   * テクスチャ取得
   */
  getTexture(name, antialiasing)
  {
    var texture = PIXI.Texture.fromFrame(name);
    texture.baseTexture.scaleMode = antialiasing? PIXI.SCALE_MODES.LINEAR:PIXI.SCALE_MODES.NEAREST;
    return texture;
  }

  /**
   * アニメーション取得
   */
  getAnimation(ns, label)
  {
    const resources = this.resources.get(ns);
    for (let key of Object.keys(resources))
    {
      const resource = resources[key];
      if(resource.data.animations && resource.data.animations[label])
      {
        return resource.data.animations[label];
      }
    }    

    return null;
  }

  /**
   * リソースがあるかどうかの判定
   */
  hasResorce(ns, name)
  {
    const resources = this.resources.get(ns);
    if(resources[name])
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  /**
   * スプライト生成
   */
  createSpriteByName(name)
  {
    return new PIXI.Sprite.from(name);
  }

  /**
   * ムービークリップ生成
   */
  createMovieClip(frames)
  {
    const textureArray = []
    for (let i = 0; i < frames.length; i++) {
      let texture = PIXI.Texture.from(frames[i])
      textureArray.push(texture)
    }
    return new PIXI.AnimatedSprite(textureArray);
  }

  /**
   * アニメーション作成
   */
  createMovieClipFromAnimation(ns, label)
  {
    const frames = this.getAnimation(ns, label);

    if(frames)
    {
      return this.createMovieClip(frames);
    }
    else
    {
      throw new Error('指定されたラベル名のアニメーションがありません');
    }
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	サウンド
  // ---------------------------------------------------------------------------------------------------------

  soundLock(bool)
  {
    this.soundLockFlag = bool
  }

  playSound(ns, name, delay = 0)
  {
    // console.log(PIXI.sound.context._ctx.state)

    const resources = this.resources.get(ns)
    if(resources[name])
    {
      if(delay == 0)
      {
        if(!this.soundLockFlag)
        {
          if((PIXI.sound.context._ctx.state == 'interrupted' || PIXI.sound.context._ctx.state == 'suspended') && document.visibilityState === 'visible') PIXI.sound.context._ctx.resume()
          resources[name].sound.play()
        }
      }
      else
      {
        const timer = gsap.delayedCall(delay, ()=>{
          if(!this.soundLockFlag)
          {
            if((PIXI.sound.context._ctx.state == 'interrupted' || PIXI.sound.context._ctx.state == 'suspended') && document.visibilityState === 'visible') PIXI.sound.context._ctx.resume()
            resources[name].sound.play()
          }
          this.soundDelayTimers.delete(name)
        })
        this.soundDelayTimers.set(name, timer)
      }
    }
  }

  stopSound(ns, name)
  {
    const resources = this.resources.get(ns)
    if(resources[name])
    {
      resources[name].sound.stop()
      if(this.soundDelayTimers.get(name))
      {
        this.soundDelayTimers.get(name).kill()
        this.soundDelayTimers.delete(name)
      }
    }
  }

  stopAllSounds()
  {
    //全ての音をとめる
    PIXI.sound.stopAll()

    //遅延再生もとめる
    this.soundDelayTimers.forEach((value, key)=>{
      value.kill()
      this.soundDelayTimers.delete(key)
    })
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	破棄
  // ---------------------------------------------------------------------------------------------------------

  destroy(ns)
  {
    const resources = this.resources.get(ns);
    for (let key of Object.keys(resources))
    {
      if(resources[key].texture) resources[key].texture.destroy(true);
      delete resources[key];
    }
    this.resources.delete(ns);
    this.config.delete(ns);
  }

  // ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.data').AssetsMananger)
  NameSpace.getNameSpace('okawari.common.data').AssetsMananger = new AssetsMananger();
export default NameSpace.getNameSpace('okawari.common.data').AssetsMananger;